import { useMantineColors } from "@/hooks";
import { Button, Flex, Loader, Text, Tooltip } from "@mantine/core";
import type { TablerIcon } from "@tabler/icons-react";

export function SquareIconButton({
  id,
  parentId,
  label,
  icon,
  tooltip,
  fullWidth = false,
  onClick,
  isActive = false,
  disabled = false,
  loading = false,
}: {
  id: string;
  parentId?: string;
  label: string;
  icon: TablerIcon;
  tooltip: string;
  fullWidth?: boolean;
  onClick: (actionId: string, parentId?: string) => void;
  isActive?: boolean;
  disabled?: boolean;
  loading?: boolean;
}) {
  const Icon = icon;
  const colors = useMantineColors();

  const buttonBackgroundColor = isActive ? "#F0F2F6" : "transparent";
  const buttonColor = disabled ? colors.gray[6] : colors.dark[6];
  const labelColor = isActive ? colors.dark[6] : undefined;

  function onClickHandler() {
    if (disabled) return;
    onClick(id, parentId);
  }

  return (
    <Tooltip
      offset={0}
      openDelay={500}
      label={tooltip}
      position="bottom"
      withArrow
    >
      <Button
        px="sm"
        fullWidth={fullWidth}
        c={buttonColor}
        color={colors.gray[2]}
        variant="white"
        h={parentId ? 60 : "100%"}
        onClick={onClickHandler}
        bg={buttonBackgroundColor}
        opacity={disabled ? 0.6 : 1}
      >
        <Flex direction="column" align="center" justify="center" gap={4}>
          {loading ? (
            <Flex align="center" justify="center" h={24} w={24}>
              <Loader size={20} />
            </Flex>
          ) : (
            <Icon size={22} stroke={1.2} />
          )}
          <Text fw={400} fz={13} c={labelColor}>
            {label}
          </Text>
        </Flex>
      </Button>
    </Tooltip>
  );
}
